var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111 30.0406V168.96C111 176.964 99.9052 181.005 93.3468 175.388L45.8098 134.672C43.8689 133.01 41.2547 132.078 38.5305 132.078H10.3738C4.64436 132.078 0 128.039 0 123.056V76.629C0 71.6459 4.64436 67.6065 10.3738 67.6065H38.4828C41.235 67.6065 43.8741 66.6556 45.8202 64.9621L93.2898 23.6617C99.8243 17.9766 111 22.0015 111 30.0406Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.017 55.6213C131.382 54.4077 135.275 54.9817 137.819 57.2585C152.005 69.9627 159.681 84.485 159.99 99.3473C160.298 114.165 153.271 128.732 139.699 141.574C137.182 143.954 133.226 144.609 129.776 143.423C123.326 141.208 121.673 133.842 125.703 128.911C133.247 119.678 137.089 109.651 136.878 99.4858C136.666 89.2664 132.362 79.234 124.353 70.0545C120.179 65.2695 121.654 57.9162 128.017 55.6213Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundLow);
export default __webpack_public_path__ + "static/media/soundLow.8ff64abd6047884127b174b042f74ff1.svg";
export { ForwardRef as ReactComponent };